import React from 'react';
import { Outlet } from 'react-router-dom';
import { ActivoClassificationProvider } from '../../../contexts/ActivoClassificationContext';

function ClasificacionActivosLayout() {
  return (
    <ActivoClassificationProvider>
      <Outlet />
    </ActivoClassificationProvider>
  );
}

export default ClasificacionActivosLayout;
